export default "__VITE_ASSET__9b94ecde__"